const STATUS_LABELS = {
  live: 'live',
  'in-progress': 'in progress',
  planned: 'planned',
}

export function formatStatus(status) {
  return STATUS_LABELS[status] ?? status
}
